// extracted by mini-css-extract-plugin
export default {"title":"title_title__teK1n","subtitle":"title_subtitle__UEfk4"};